const empty = () =>
    import ( /* webpackChunkName: "empty" */ '../views/Empty.vue');

const AskManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/ask/AskManage.vue');
const AnswerManage = () =>
    import ( /* webpackChunkName: "question" */ '../views/ask/AnswerManage.vue');
const AskCourse = () =>
    import ( /* webpackChunkName: "question" */ '../views/ask/AskCourse.vue');
const AskQuestion = () =>
    import ( /* webpackChunkName: "question" */ '../views/ask/AskQuestion.vue');
const AskSetting = () =>
    import ( /* webpackChunkName: "question" */ '../views/ask/AskSetting.vue');
const WithdrawManage = () =>
    import ( /* webpackChunkName: "withdraw" */ '../views/ask/WithdrawManage.vue');
const WithdrawRecord = () =>
    import ( /* webpackChunkName: "withdraw" */ '../views/ask/WithdrawRecord.vue');
const WithdrawQues = () =>
    import ( /* webpackChunkName: "withdraw" */ '../views/ask/WithdrawQues.vue');

export default [{
    path: 'ask',
    name: 'Ask',
    component: empty,
    children: [
      {
        path: 'ask',
        name: 'AskManage',
        component: empty,
        children: [
        {
                path: '/',
                name: 'AskManage',
                component: AskManage,
                meta: {
                    title: '问答板块',
                    keepAlive: true,
                    root: true
                },
            },
            {
                path: 'course',
                name: 'AskCourse',
                component: AskCourse,
                meta: {
                    title: '课程问答',
                    root: true
                },
            },
            {
                path: 'question',
                name: 'AskQuestion',
                component: AskQuestion,
                meta: {
                    title: '题目问答',
                    root: true
                },
            },
            {
                path: 'answer',
                name: 'AnswerManage',
                component: AnswerManage,
                meta: {
                    title: '问答详情'
                },
              },
              {
                  path: 'setting',
                  name: 'AskSetting',
                  component: AskSetting,
                  meta: {
                      title: '分成设置',
                      root: true
                  },
                }
            ]
      },
      {
                path: 'withdraw',
                name: 'Withdraw',
                component: empty,
                children: [{
                        path: '/',
                        name: 'WithdrawManage',
                        component: WithdrawManage,
                        meta: {
                            title: '财务结算',
                            keepAlive: true,
                            root: true
                        }
                      },{
                        path: 'record',
                        name: 'WithdrawRecord',
                        component: WithdrawRecord,
                        meta: {
                            title: '提现记录',
                            keepAlive: true,
                            root: true
                        },
                    },{
                      path: 'question',
                      name: 'WithdrawQues',
                      component: WithdrawQues,
                      meta: {
                          title: '常见问题',
                      },
                }],
            }
      ]
}]
